import { css } from '@emotion/react';
import { observer } from 'mobx-react-lite';
import type { ReactElement } from 'react';
import { useIntl } from 'react-intl';
import { ChatAttachmentTypeEnum } from 'sdk';

import { useSDK } from '../../../../../app';
import { commonMessages } from '../../../../../i18n/commonMessages';
import { styled } from '../../../../../styled';
import { DownloadAttachButton } from './downloadAttachButton';
import { FileDescription } from './fileDescription';
import { FileIcon } from './fileIcon';
import { Filename } from './filename';

const styles = css`
	display: flex;
	padding: 4px;
	width: 194px;

	& > div:first-of-type {
		padding-right: 12px;
	}

	& > a {
		display: none;
	}
`;
const Component = ({ id, className }: { id: number; className: string }): ReactElement | null => {
	const rootStore = useSDK();
	const attachmentInfo = rootStore.attachmentsStore.getAttachmentInfo(id);
	const intl = useIntl();
	if (attachmentInfo) {
		const onClick = async (): Promise<void> => {
			const a = document.createElement('a');
			a.target = '_blank';
			a.rel = 'noreferrer';
			a.href = (await rootStore.attachmentsStore.refreshAndGetAttachmentUrl(id)) as string;
			a.download = attachmentInfo.filename;
			a.click();
		};
		return (
			<div className={className}>
				<div>
					<FileIcon />
				</div>
				<div>
					<Filename filename={attachmentInfo.filename} />
					<FileDescription attachment={attachmentInfo} />
					{attachmentInfo.type === ChatAttachmentTypeEnum.OperatorAttach && (
						<DownloadAttachButton onClick={onClick}>
							{intl.formatMessage(commonMessages.download)}
						</DownloadAttachButton>
					)}
				</div>
			</div>
		);
	}
	return null;
};

export const FilePreview = styled(observer(Component))(styles);
